export default {
  ACTIVE: 'active',
  CLOSED: 'closed',
};
